import TableView from 'mini-mail-list-store/lib/store/schema/TableView';

export default function getCanTableLoadMore(tableView: TableView): boolean {
    // If we have no more items locally in store, check if there are more items on server
    // We can only support load more SeekToCondition request if we have any items left on the client
    // VSO 12854: Listview should load more if user deletes all items that's on the client but the server has more rows
    return tableView.itemIds.length > 0 && tableView.itemIds.length < tableView.totalRowsInView;
}
